// src/hooks/useBlog.js
import { getData, postData, updateData, deleteData } from "../services/apiService";

// Get all blogs
export const fetchBlogs = () => getData("/all-blogs");

// Get single blog
export const fetchBlogById = (id) => getData(`/blogs/${id}`);

// Create blog (with multiple images)
export const createBlog = (formData) => postData("/add-blog", formData, true);

// Update blog
export const editBlog = (id, formData) => updateData(`/update-blog/${id}`, formData, true);

// Delete blog
export const removeBlog = (id) => deleteData(`/delete-blog/${id}`);
